import { Controller } from "@hotwired/stimulus"
// maps stores location
export default class extends Controller {
  static targets = ["field", "map", "latitude", "longitude"]

  connect() {
    // Check if Google Maps API is fully loaded (including Map constructor)
    if (this.isGoogleMapsReady()) {
      this.initMap()
    } else {
      // Wait for API to load
      this.waitForGoogleMaps()
    }
  }

  isGoogleMapsReady() {
    return typeof google !== "undefined" &&
           google.maps &&
           google.maps.Map &&
           google.maps.LatLng &&
           google.maps.places
  }

  waitForGoogleMaps() {
    const checkInterval = setInterval(() => {
      if (this.isGoogleMapsReady()) {
        clearInterval(checkInterval)
        this.initMap()
      }
    }, 100)

    // Timeout after 10 seconds
    setTimeout(() => {
      clearInterval(checkInterval)
      if (!this.isGoogleMapsReady()) {
        console.warn("Google Maps no se pudo cargar")
      }
    }, 10000)
  }

  initMap() {
    // connect y el callback de Google pueden llegar en la misma carga.
    if (this.map) return

    if (!this.hasMapTarget || !this.hasFieldTarget || !this.hasLatitudeTarget || !this.hasLongitudeTarget) {
      console.warn("❗ Faltan uno o más targets: map, field, latitude o longitude")
      return
    }

    const defaultLatitude = parseFloat(this.data.get("latitude") || -33.42)
    const defaultLongitude = parseFloat(this.data.get("longitude") || -70.60)

    this.map = new google.maps.Map(this.mapTarget, {
      center: new google.maps.LatLng(defaultLatitude, defaultLongitude),
      zoom: this.data.get("latitude") ? 17 : 4
    })

    this.marker = new google.maps.Marker({
      map: this.map,
      draggable: true,
      anchorPoint: new google.maps.Point(0, -29)
    })
    this.marker.addListener("dragend", () => {
      const position = this.marker.getPosition()
      this.latitudeTarget.value = position.lat()
      this.longitudeTarget.value = position.lng()
      this.map.panTo(position)
    })

    // Mostrar marcador si ya hay coordenadas cargadas (modo edición)
    if (this.data.get("latitude") && this.data.get("longitude")) {
      const position = new google.maps.LatLng(defaultLatitude, defaultLongitude)
      this.marker.setPosition(position)
      this.marker.setVisible(true)
    }

    this.autocomplete = new google.maps.places.Autocomplete(this.fieldTarget)
    this.autocomplete.bindTo('bounds', this.map)
    this.autocomplete.setFields(['address_components', 'geometry', 'icon', 'name'])
    this.autocomplete.addListener('place_changed', this.placeChanged.bind(this))
  }

  placeChanged() {
    const place = this.autocomplete.getPlace()

    if (!place.geometry) {
      window.alert(`No se encontraron detalles para: ${place.name}`)
      return
    }

    if (place.geometry.viewport) {
      this.map.fitBounds(place.geometry.viewport)
    } else {
      this.map.setCenter(place.geometry.location)
      this.map.setZoom(17)
    }

    this.marker.setPosition(place.geometry.location)
    this.marker.setVisible(true)

    this.latitudeTarget.value = place.geometry.location.lat()
    this.longitudeTarget.value = place.geometry.location.lng()
  }

  keydown(event) {
    if (event.key === "Enter") {
      event.preventDefault()
    }
  }
}
